(function ($) {
    var aycomaps = function() {
        var _aycomap = null;
        var _settings = {};
        var _arr_markers = [];
        var _controlSearch = null;
        var _markersLayer = null;
        var _heatmapLayer = null;
        var _markersFG = null;

        var init = function (options) {
            _markersLayer = new L.LayerGroup();
            _heatmapLayer = new L.LayerGroup();

            _settings = $.extend($.fn.aycomaps.defaults, options || {});
            if (_aycomap != undefined || _aycomap != null) {
                removeAllMarkers();
                destroy();
            }
            var defaultLayer;

            var osm = new L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            })

            var GoogleMaps = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
                maxZoom: 18,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            });
            var GoogleMapsRoads = L.tileLayer('http://{s}.google.com/vt/lyrs=h&x={x}&y={y}&z={z}', {
                attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
                maxZoom: 18,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            });

            var ESRIWorld = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}');

            var ESRIRoads = L.tileLayer('https://{s}.tile.openstreetmap.se/hydda/roads_and_labels/{z}/{x}/{y}.png', {
                maxZoom: 18
            });

            if (_settings.defaultLayer == "googleMaps") {
                defaultLayer = [GoogleMaps, GoogleMapsRoads]
            } else {
                if (_settings.defaultLayer == "OSM") {
                    defaultLayer = osm
                } else {
                    defaultLayer = [ESRIWorld, ESRIRoads]
                }
            }

            _aycomap = L.map(_settings.id, {
                layers: defaultLayer,
                minZoom: _settings.minZoom,
                zoomSnap: _settings.zoomStep,
                zoomDelta: _settings.zoomStep,
                attributionControl: _settings.attribution
            })
            _aycomap.invalidateSize();

            if (_settings.search) {

                var iconSearchUrl = "https://cdn.mapmarker.io/api/v1/pin?icon=fa-search&size=40&color=FFF&hoffset=-0.5&voffset=-1";
                var markeroptions = {
                    bounceAdd: true,
                    draggable: true,
                    icon: L.icon({
                        iconUrl: iconSearchUrl,
                        iconSize: [40, 40],
                        iconAnchor: [(40 / 2), 40]
                    })
                }
                var searchmarker = L.marker([0, 0], markeroptions);
                if (typeof _settings.fnDragSearch == "function") {
                    searchmarker.on('dragend', function (event) {
                        var returndata = {
                            latitud: searchmarker.getLatLng().lat,
                            longitud: searchmarker.getLatLng().lng
                        };
                        _settings.fnDragSearch.call(null, returndata);
                    });
                }
                _controlSearch = new L.Control.Search({
                    url: 'http://nominatim.openstreetmap.org/search?format=json&q={s}',
                    jsonpParam: 'json_callback',
                    propertyName: 'display_name',
                    propertyLoc: ['lat', 'lon'],
                    marker: searchmarker,
                    autoCollapse: true,
                    autoType: false,
                    minLength: 2,
                    initial: false,
                    position: 'topright'
                });
                _aycomap.addControl(_controlSearch);
                if (_settings.inputSearch) {
                    $(_settings.inputSearch).on('keyup', function (e) {
                        _controlSearch.searchText(e.target.value);
                    })
                }
            }
            if (_settings.layerSelector) {
                var baseLayers = {
                    "GoogleMaps": GoogleMaps,
                    "ESRIWorld": ESRIWorld,
                    "OSM": osm
                };

                var overlays = {
                    "GoogleMapsRoads": GoogleMapsRoads,
                    "ESRIRoads": ESRIRoads,
                    "Ver marcadores": _markersLayer
                };

                var positionControl = 'topright';
                if (_settings.search) {
                    positionControl = 'bottomright'
                }
                L.control.layers(baseLayers, overlays, {position: positionControl}).addTo(_aycomap);
            }

            var mapdata = {
                markers: $("#" + options.id).attr("data-markers"),
                latitud: $("#" + options.id).attr("data-latitud"),
                longitud: $("#" + options.id).attr("data-longitud"),
                zoom: $("#" + options.id).attr("data-zoom"),
            }
            if (typeof mapdata.markers != "undefined") {
                var marcadores = mapdata.markers;
                if (marcadores.length > 0) {
                    add.markers(marcadores)
                }
            }
            var init_lat = _settings.initial_position[0];
            var init_lng = _settings.initial_position[1];
            var init_zoom = _settings.initial_zoom;
            if (typeof mapdata.latitud != "undefined") {
                if (mapdata.latitud != "") {
                    init_lat = parseFloat(mapdata.latitud);
                }
            }
            if (typeof mapdata.longitud != "undefined") {
                if (mapdata.longitud != "") {
                    init_lat = parseFloat(mapdata.longitud);
                }
            }
            if (typeof mapdata.zoom != "undefined") {
                if (mapdata.zoom != "") {
                    init_zoom = parseFloat(mapdata.zoom);
                }
            }
            _aycomap.setView([init_lat, init_lng], init_zoom);
        }
        var destroy = function () {
            _aycomap.off();
            _aycomap.remove();
            _aycomap = null;
        }
        var removeAllMarkers = function () {
            _markersLayer.eachLayer(function (layer) {
                layer.remove();
                _aycomap.removeLayer(layer);
            });
            _markersLayer = new L.LayerGroup();
            _arr_markers = [];
        }
        var resetMap = function () {
            hide.all();
            destroy();
            init(_settings);
        }
        var fitBounds = function () {
            _markersFG = new L.featureGroup(_arr_markers);
            _aycomap.fitBounds(_markersFG.getBounds().pad(0.1))
        }
        var search = function (termino) {
            _controlSearch.searchText(termino);
        }
        var centerMapOnAddress = function (address, zoom, add_marker, fnDrag, fnClick) {
            zoom = (zoom) ? zoom : 14;
            $.ajax({
                url: 'https://nominatim.openstreetmap.org/',
                type: 'GET',
                data: {
                    q: address,
                    limit: 1,
                    format: "json",
                    addressdetails: 1
                },
                dataType: "json",
                beforeSend: function () {
                },
                success: function (data) {
                    if (data) {
                        if (data[0]) {
                            var el = data[0];
                            var center_latitud = parseFloat(el.lat),
                                center_longitud = parseFloat(el.lon);

                            if (add_marker) {
                                remove.marker("searchmarker");
                                add.marker({
                                    id: "searchmarker",
                                    nombre: address,
                                    latitud: center_latitud,
                                    longitud: center_longitud,
                                    draggable: true,
                                    color: "#000066",
                                    iconSize: 40,
                                    icon: "fa-home",
                                    avoidFit: true
                                }, fnDrag, fnClick);
                            }
                            _aycomap.setView([center_latitud, center_longitud], zoom);
                        }
                    }
                }
            });
        };
        var reverseGeocode = function (latitud, longitud, target) {
            $.ajax({
                url: 'https://nominatim.openstreetmap.org/reverse',
                type: 'GET',
                data: {
                    lat: latitud,
                    lon: longitud,
                    zoom: 21,
                    addressdetails: 1,
                    format: 'json'
                },
                dataType: "json",
                beforeSend: function () {
                },
                success: function (data) {
                    if (data) {
                        if (target) {
                            target.html(data.display_name)
                        }
                    }
                }
            });
        };
        var addHeatMap = function (points, radius, blur) {
            var maxWeight = 0;
            var heat_map = [];
            for (var i = 0; i < points.length; i++) {
                var weight = parseFloat(points[i].weight);
                if (weight > maxWeight) {
                    maxWeight = weight
                }
            }
            for (var i = 0; i < points.length; i++) {
                var heatmap_point = [
                    points[i].latitud,
                    points[i].longitud,
                    points[i].weight
                ];
                heat_map.push(heatmap_point);
            }
            var heatmap = L.heatLayer(heat_map, {radius: radius, blur: blur, max: maxWeight}).addTo(_aycomap);
            _heatmapLayer.addLayer(heatmap);
            _heatmapLayer.addTo(_aycomap);
        };

        var addMarker = function (options) {
            var markeroptions = {
                draggable: options.draggable || false,
                id: options.id || "",
                title: options.nombre || ""
            };

            var size = parseInt(options.iconSize) || 60;
            if (options.color) {
                var color = options.color.replace('#', '');
                var iconUrl = "";
                var textcolor = (parseInt(color.replace('#', ''), 16) > 0xffffff / 2) ? '000000' : 'ffffff';

                var shadow = false;
                if (options.nopin) {
                    if (options.icon) {
                        iconUrl = "https://cdn.mapmarker.io/api/v1/fa/stack?icon=" + options.icon + "&color=FFF&size=" + size + "&on=fa-circle&oncolor=" + color;
                    } else {
                        iconUrl = "https://cdn.mapmarker.io/api/v1/fa/?icon=fa-arrow-down&color=" + color + "&size=" + size + "&on=fa-circle&oncolor=" + color;
                    }
                } else {
                    shadow = true;
                    if (options.icon) {
                        iconUrl = "https://cdn.mapmarker.io/api/v1/pin?icon=" + options.icon + "&size=" + size + "&background=" + color + "&color=" + textcolor;
                        if (size < 60) {
                            iconUrl += "&hoffset=-0.5&voffset=-1"
                        } else {
                            iconUrl += "&hoffset=1.5&voffset=-1"
                        }
                    } else {
                        if (options.iconText) {
                            iconUrl = "https://cdn.mapmarker.io/api/v1/pin?text=" + options.iconText + "&size=" + size + "&background=" + color + "&color=" + textcolor + "&hoffset=-1";
                        } else {
                            iconUrl = "https://cdn.mapmarker.io/api/v1/pin?icon=fa-circle&size=" + size + "&background=" + color + "&color=FFF&hoffset=-0.5&voffset=-1";
                        }
                    }
                }
                if (iconUrl != "") {
                    var shadowUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAyCAYAAAD2vz2aAAAD40lEQVRoQ+2Zh27kMAxEJ9d7L///fXe43jseoAEIwdmYWWntA2iAcONm7ZfhiNKeqbYUgbNUdiWrgCVFUMAKWJJAMr0UVsCSBJLppbACliSQTC+FFbAkgWR6KayAJQkk00thBSxJIJleCitgSQLJ9FJYAUsSSKaXwgpYkkAyvRRWwJIEkul7VZifi30MXs/3/rZ3Zd9HEsP69L0Ai1CuSIpxtUHi2hKwP5IcvyURPjfU9UQuyNwaWA/mmiQA9XuukWuwvJZVZUi/JP3swvD+a2B+aSAQ10Pc6M65Z3gRmoGhJKAA64ek75K+tvjWzrlH3pDtlAqLoAzppqQYtyQBjQDUEqzoYagMGFYXwD5L+iTpY9sDjvtDyvNUwFx6gAIGYG53ATgrzLB6P+uf18AMDZUB7IOkt5LetXNAosSjt1MA46UBABBA3ZF0twXHXDOs8xQVvSs+cxwdgYaHUZKAeiPptaT37RoqO3qbDcweZVD3Jd1rATSuuzztaX0bsfYlgYeKAAakVy2sst0DQ1mUGKUHpIeSHkgCmpUFLJu524a1gPo8gAHFCovAuLZrYKgEGMAC0iNJj9sxsChBl98IlVtdeBiGj39RjpQlfrZ7D0M1QAHWkxYAowwNKyoKaIdGsSWozndrAawvDRCgDItreNuuR0nUhZKA9FzS01aSKA5lxalPtgTjlMg9mPsvWgn8C99CWcAC5JARMk4zsg99UT4qwrcA9aLt8S6u91Oci/6W70dQsfeizwIMpQgkgmMrC1hD1DULGOoBDICeSXrZShKADAKxRVgDqwcFAErMqnKjCiSCc+6hLMAOg7UVsLWjYXxR+xSgAMGoZ1UZEueojfueDg2FNRMYSkJhlCQKY8/5WoWd51MuP6uKPaAACCiAeqVijXrTOSOG9KUvNTBGSANjxOS6Vx2WPrfkU4AAFFBi+RkU5Qcoe9VwVcUHnQWMURLPAhimz0iJwujsl4Ad8inAACqqCnj2KS/hTAVlaLOA0TrQc9FWoDCAoTCAeUHQSzR+liWfiqDwKkBN96lDdToLGFAARoePwgimRvRh3IubPceG3vuUWwSDiuWX9qBjPzATGHAiMI7duFpdXi21T7n8PPKhMC8EGtSwxcDLwJsFDJ8CDqqiF0NhlCfdPwrz3G+pn3IZuvwiqJP41BYlyT8Cv3JrATQrDGCoxEvKvao296mtgDFS2se8UuFRksYyduqoymvxbjyHTmkuU35Ln5lVknwXIyWAgOY1MPowtggMj+oNfVOf2kJhfGdcmo5L0Abmn8SioobP/UYpa3Yf5mkX0Lz07JVV/3Ax/UfX0bD4e/8AQnpPQkCNTJQAAAAASUVORK5CYII=';
                    markeroptions['icon'] = L.icon({
                        iconUrl: iconUrl,
                        iconSize: [size, size],
                        iconAnchor: [(size / 2), size],
                        shadowSize: ((shadow) ? [(size * 1.5), size] : false),
                        shadowUrl: ((shadow) ? shadowUrl : false),
                        shadowAnchor: ((shadow) ? [(size / 2), size + (size / 20)] : false),
                    });
                }
            }

            var marker = L.marker([options.latitud, options.longitud], markeroptions);
            _markersLayer.addLayer(marker);
            _arr_markers.push(marker);

            var textoPopup = options.html || false;
            if (textoPopup) {
                if (_settings.tooltip) {
                    marker.bindTooltip(textoPopup, {direction: 'top', offset: [0, (size * (-1) + (size / 5))]})
                } else {
                    marker.bindPopup(textoPopup, {offset: [0, (size * (-1) + (size / 5))]});
                }
            }

            var returndata = {
                latitud_original: options.latitud,
                longitud_original: options.longitud
            }

            if (typeof options.fnDrag == "string") {
                options.fnDrag = (new Function('return ' + options.fnDrag))(returndata);
            }
            var fnDrag = options.fnDrag || function () {
            };
            if (options.draggable) {
                marker.on('dragend', function (ev) {
                    returndata['latitud'] = ev.target.getLatLng().lat;
                    returndata['longitud'] = ev.target.getLatLng().lng;
                    if (typeof fnDrag == "function") {
                        fnDrag.call(null, returndata);
                    }

                });
            }


            if (typeof options.fnClick == "string") {
                options.fnClick = (new Function('return ' + options.fnClick))(returndata);
            }
            var fnClick = options.fnClick || function () {
            };
            marker.on('click', function (ev) {
                returndata['latitud'] = ev.target.getLatLng().lat;
                returndata['longitud'] = ev.target.getLatLng().lng;
                if (typeof fnClick == "function") {
                    fnClick.call(null, returndata);
                }
            });

            _markersLayer.addTo(_aycomap);

            if (_settings.fitBounds && !options.avoidFit) {
                fitBounds();
            }
        };

        var getMarker = function (id) {
            var marker;
            _markersLayer.eachLayer(function (layer) {
                var opts = layer.options;
                if (id == opts.id) {
                    marker = layer;
                }
            });
            return marker;
        };
        var setCenter = function (lat, lon, zoom) {
            _aycomap.setView([lat, lon], zoom)
        };

        var add = {
            marker: function (opts, fnDrag, fnClick) {
                var options = $.extend({}, opts);
                if (typeof options == "string") {
                    options = JSON.parse(options)
                }
                options.latitud = parseFloat(options.latitud);
                options.longitud = parseFloat(options.longitud);
                if (typeof fnDrag == "function") {
                    options.fnDrag = fnDrag
                } else {
                    if (typeof options.fnDrag != "string") {
                        options.fnDrag = false;
                    }
                }
                if (typeof fnClick == "function") {
                    options.fnClick = fnClick
                } else {
                    if (typeof options.fnClick != "string") {
                        options.fnClick = false;
                    }
                }
                addMarker(options)
            },
            markers: function (json, fnDrag, fnClick) {
                if (typeof json == "string") {
                    json = JSON.parse(json)
                }
                if (json.length > 0) {
                    $.each(json, function (i, options) {
                        if (typeof fnDrag == "function") {
                            options.fnDrag = fnDrag
                        } else {
                            if (typeof options.fnDrag != "string") {
                                options.fnDrag = false;
                            }
                        }
                        if (typeof fnClick == "function") {
                            options.fnClick = fnClick
                        } else {
                            if (typeof options.fnClick != "string") {
                                options.fnClick = false;
                            }
                        }
                        add.marker(options)
                    });
                } else {

                    if (typeof fnDrag == "function") {
                        json.fnDrag = fnDrag
                    } else {
                        if (typeof json.fnDrag != "string") {
                            json.fnDrag = false;
                        }
                    }
                    if (typeof fnClick == "function") {
                        json.fnClick = fnClick
                    } else {
                        if (typeof json.fnClick != "string") {
                            json.fnClick = false;
                        }
                    }
                    add.marker(json)
                }
            },
            heatMap: function (points, radius, blur) {
                if (typeof points == "string") {
                    points = JSON.parse(points)
                }
                addHeatMap(points, radius, blur)
            }
        };
        var hide = {
            markers: function () {
                _markersLayer.eachLayer(function (layer) {
                    layer.remove();
                    _aycomap.removeLayer(layer);
                });
            },
            heatMap: function () {
                _heatmapLayer.eachLayer(function (layer) {
                    layer.remove();
                    _aycomap.removeLayer(layer);
                });
            }
        }
        var remove = {
            marker: function (id, callback) {
                var found = false;
                _markersLayer.eachLayer(function (layer) {
                    var opts = layer.options;
                    if (id == opts.id) {
                        found = true;
                        layer.remove();
                        _aycomap.removeLayer(layer);

                        if (typeof callback == "function") {
                            callback.call()
                        }
                    }
                });
            }
        };

        return {
            destroy: function () {
                destroy()
            },
            removeAllMarkers: function () {
                removeAllMarkers()
            },
            resetMap: function () {
                resetMap()
            },
            fitBounds: function () {
                fitBounds()
            },
            search: function (termino) {
                search(termino)
            },
            searchAddress: function (termino, fnDrag, fnClick) {
                centerMapOnAddress(termino, 16, true, fnDrag, fnClick);
            },
            centerMapOnAddress: function (address, zoom, add_marker, fnDrag, fnClick) {
                centerMapOnAddress(address, zoom, add_marker, fnDrag, fnClick)
            },
            reverseGeocode: function (latitud, longitud, target) {
                reverseGeocode(latitud, longitud, target);
            },
            addHeatMap: function (points, radius, blur) {
                addHeatMap(points, radius, blur);
            },
            addMarker: function (options) {
                addMarker(options)
            },
            getMap: function () {
                return _aycomap;
            },
            getMarker: function (id) {
                getMarker(id)
            },
            setCenter: function (lat, lon, zoom) {
                setCenter(lat, lon, zoom)
            },
            add: {
                marker: function (opts, fnDrag, fnClick) {
                    add.marker(opts, fnDrag, fnClick);
                },
                markers: function (json, fnDrag, fnClick) {
                    add.markers(json, fnDrag, fnClick);
                },
                heatMap: function (points, radius, blur) {
                    add.heatMap(points, radius, blur);
                }
            },
            hide: {
                markers: function () {
                    hide.markers();
                },
                heatMap: function () {
                    hide.heatMap();
                },
                all: function () {
                    hide.markers();
                    hide.heatMap();
                }
            },
            remove: {
                marker: function (id, callback) {
                    remove.marker(id, callback)
                }
            },
            init: init
        }
    };


    $.fn.aycomaps = function (defaultLayer, options) {
        if (typeof options == "undefined") {
            options = {};
        }
        options.defaultLayer = defaultLayer;
        var maps = [];
        this.each(function(index){
            var mapcontainer = $(this);
            var mapid = mapcontainer.attr("id");
            if(mapid!=""){
                options.id = mapid;
            }else{
                var time = new Date().getTime();
                options.id = "aycomap_" + time;
                $(mapcontainer[index]).attr("id", "aycomap_" + time);
            }

            var aycomapa = new aycomaps();
            aycomapa.init(options);
            maps.push(aycomapa);
        });
        if(maps.length>1){
            return maps;
        }else{
            return maps[0];
        }

    };


    $.fn.aycomaps.defaults = {
        id: 'aycomap',
        defaultLayer: "ESRI",
        destroy: true,
        layerSelector: false,
        fitBounds: true,
        search: false,
        fnDragSearch: function () {
        },
        inputSearch: ".search_map",
        minZoom: 0,
        zoomStep: 0.25,
        tooltip: false,
        initial_position: [42.234615, -8.716313],
        initial_zoom: 10
    };

})(jQuery);
